import { render, staticRenderFns } from "./TicketHub.vue?vue&type=template&id=e05a967c&"
import script from "./TicketHub.vue?vue&type=script&lang=js&"
export * from "./TicketHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports